import { object, string } from "yup";

import { exportInfoColumn, imortInfoColumn } from "./columns";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";

export const processTypeName = {
  import: "Import Open Truck",
  export: "Export Open Truck",
};
export const imortInfoList = [
  { sNo: 1, fromWeBOC: "VGIL", fromNTOS: "SRCO" },
  { sNo: 2, fromWeBOC: "GDIO", fromNTOS: "GTOO" },
  { sNo: 3, fromWeBOC: "IHCO", fromNTOS: "" },
  { sNo: 4, fromWeBOC: "ECMO", fromNTOS: "" },
  { sNo: 5, fromWeBOC: "CRLO", fromNTOS: "" },
];

export const exportInfoList = [
  { sNo: 1, fromWeBOC: "OPIA", fromNTOS: "OGIE" },
  { sNo: 2, fromWeBOC: "OGDE", fromNTOS: "OSRC" },
  { sNo: 3, fromWeBOC: "OEHC", fromNTOS: "OGTE" },
  { sNo: 4, fromWeBOC: "OECM", fromNTOS: "" },
  { sNo: 5, fromWeBOC: "OCRL", fromNTOS: "" },
];

export const getInfoColumns = (processType?: any) => {
  if (processType) {
    if (processType == processTypeName.import) {
      return imortInfoColumn;
    }
    if (processType == processTypeName.export) {
      return exportInfoColumn;
    }
  }
};

export const getInfoRows = (processType?: any) => {
  if (processType) {
    if (processType == processTypeName.import) {
      return imortInfoList;
    }
    if (processType == processTypeName.export) {
      return exportInfoList;
    }
  }
};

export const getLabel = (processType?: any) => {
  if (processType) {
    if (processType == processTypeName.import) {
      return "Bill Number";
    }
    if (processType == processTypeName.export) {
      return "GD Number";
    }
  }
};

export const getColumn = (processType?: any, impDisplayColumns?: any, expDisplayColumns?: any) => {
  if (processType) {
    if (processType == processTypeName.import) {
      return impDisplayColumns;
    }
    if (processType == processTypeName.export) {
      return expDisplayColumns;
    }
  }
};

export const addSerialNumber = async (rows: any) => {
  const transformedData = await rows?.map((row: any, index: number) => ({
    ...row,
    id: index,
    sNo: index + 1,
  }));
  return transformedData;
};

export function transformKey(key: string) {
  return key
    .split("_")
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const validationSchema = object({
  processType: string().required("This field is required."),
  gdNumber: string()
    .max(50, "Maximum 50 characters are allowed")
    .required("This field is required."),
});

export const gridMaxHeightHandler = () => {
  const { height } = UseWindowDimensions();
  let wHeight = 0;
  let gridMaxHeight = 0;
  let dppr = 10;
  wHeight = height - 132;
  gridMaxHeight = height - 200;
  if (height > 700 && height < 900) {
    dppr = 15;
  } else if (height > 900) {
    dppr = 25;
  } else {
    dppr = 10;
  }
  return { gridMaxHeight, dppr, wHeight };
};
